import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.19_db0@0.3.2_e_72f7c991f442de09c7dad6ce52096d83/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}